import React from "react";

import { useTranslation } from "react-i18next";

import type { CategoryKey } from "~/sdks/LocalContent/types";

import * as styles from "./styles";

export function CategoryTitle({
  categoryKey,
  className,
}: {
  categoryKey: CategoryKey;
  className?: string;
}) {
  const { t } = useTranslation("localContent");

  return (
    <h3
      className={`${styles.container} ${className}`}
      data-testid="category-title"
      data-category-key={categoryKey}
    >
      {t(`categories.${categoryKey}`)}
    </h3>
  );
}
